

























































import Vue from 'vue';
import Component from 'vue-class-component';
import Comment from './Comment.vue';
import { PropSync } from 'vue-property-decorator';
import * as FORM_INTERFACE from '../tickets-form/interfaces/accessTicket.interface';

@Component({
    components: { Comment },
})
export default class CommentsDrawer extends Vue {
    drawer = true;
    showTooltip = !this.drawer;
    colors = ['green', 'blue', 'yellow', 'orange', 'purple'];
    filterWord: string = '';

    @PropSync('currentStep', { default: 6 })
    step!: number;

    @PropSync('commentsProp', {
        default: function() {
            return Array();
        },
    })
    comments!: FORM_INTERFACE.workflowCommentsInterface[];

    get nonDuplicateComments() {
        const items: FORM_INTERFACE.workflowCommentsInterface[] = this.comments.filter(
            i => i.comment !== null,
        );
        const distinctComments: string[] = [...new Set(items.map(i => i.comment))];
        return [
            ...distinctComments.map(comment => {
                return items.find(j => j.comment === comment);
            }),
        ] as Array<FORM_INTERFACE.workflowCommentsInterface>;
    }

    get getComments() {
        if (this.filterWord.length) {
            return this.nonDuplicateComments.filter(
                i =>
                    (i.comment.toLowerCase().includes(this.filterWord.toLowerCase()) ||
                        i.stepName.toLowerCase().includes(this.filterWord.toLowerCase())) &&
                    (i.stepID == this.step || this.step == 6),
            );
        } else {
            return this.nonDuplicateComments.filter(i => i.stepID == this.step || this.step == 6);
        }
    }

    showStepName(key: number) {
        if (key == 0 || this.getComments[key].stepID != this.getComments[key - 1].stepID) {
            return true;
        } else {
            return false;
        }
    }

    showDivider(key: number) {
        if (
            key == this.getComments.length - 1 ||
            this.getComments[key].stepID != this.getComments[key + 1].stepID
        ) {
            return true;
        } else {
            return false;
        }
    }
}
